export default __webpack_public_path__ + "static/media/nft.6932221b.png";